import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TopBannerComponent } from '../../shared/components/top-banner/top-banner.component';

@Component({
  templateUrl: './terms.component.html',
  standalone: true,
  imports: [TopBannerComponent]
})
export class TermsComponent {

  constructor(private router: Router) { }

  public logoClick(): void {
    this.router.navigate(['account/login']);
  }
}
